module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/favicon-32x32.png";